export class TemplateSelectorUtils {
  static canKeepScrolling(element) {
    const el = element.nativeElement;
    return !(el.scrollHeight - el.scrollTop - el.clientHeight < 1);
  }
}
